import { permissionAllowed, UserSystemDisplay } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { DisplayCategory } from "@ews/zlt-events";
import { DisplayCategoryTranslation } from "@ews/zlt-events/dist/types";
import { IonButton, IonItem, IonList } from "@ionic/react";
import { Locale } from "../../../../setup/locale";
import { MAX_DEVICE_NUMBER } from "../../../../utils";
import { useMyPermissions, useMyProfileId } from "../../../Login/LoginProvider";
import { useModifyUserSystemDisplay, useUserSystemDisplay } from "../../../ReactData/user";
import { useIsMobile } from "../../../Responsive";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsSelect from "../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect";
import SettingsSelectOption from "../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import SettingsTitle from "../../../Settings/SettingsTitle/SettingsTitle";
import { SystemViewSettingsProps } from "./types";

const SystemViewSettings: React.FC<SystemViewSettingsProps> = ({ id }) =>
{
    const systemDisplay = useUserSystemDisplay(id!);
    const modifyUserSystemDisplay = useModifyUserSystemDisplay();
    const { translate: t } = useL10n();
    const isMobile = useIsMobile();

    const myPermissions = useMyPermissions();
    const myId = useMyProfileId();
    const allowedToEdit = myId === id ? true : permissionAllowed(myPermissions.createUser || 0);

    const modifySystemDisplay = async (data: UserSystemDisplay) =>
    {
        await modifyUserSystemDisplay(id!, data);
    };

    if (!("displayCategory1" in systemDisplay)) return <></>;

    const filters = Array(5).fill(1).map((v, n) => n + 1);
    const displayCategories = Object.keys(DisplayCategory).filter(v => !isNaN(+v));
    const Wrapper = isMobile ? IonList : IonItem;


    return <>
        <SettingsCol xl="6">

            <SettingsTitle text={"PLG_USER_PROFILE_LST_FIELD_SYSTEM_ONLY_EVENTS"} />
            {filters.map(index =>
            {
                const category = `displayCategory${index}` as keyof UserSystemDisplay;
                const zoneFrom = `firstZone${index}` as keyof UserSystemDisplay;
                const zoneTo = `lastZone${index}` as keyof UserSystemDisplay;

                return <Wrapper lines="full" key={index}>
                    <SettingsSelect
                        disabled={!allowedToEdit}
                        text={isMobile ? '[REACT_EVENT_LOWERCASE]' : ''}
                        value={`${systemDisplay[category]}`}
                        onSelect={(value) =>
                        {
                            modifySystemDisplay({ [category]: parseInt(value) } as unknown as UserSystemDisplay);
                        }}
                    >
                        {displayCategories.map((v, i) =>
                        {
                            const key: keyof typeof DisplayCategoryTranslation = DisplayCategory[v as keyof typeof DisplayCategory] as unknown as keyof typeof DisplayCategoryTranslation;
                            return <SettingsSelectOption
                                value={v}
                                key={i}
                                text={DisplayCategoryTranslation[key] as Locale}
                            ></SettingsSelectOption>;
                        })}

                    </SettingsSelect>
                    {!isMobile && <div style={{ whiteSpace: "nowrap" }}
                        hidden={systemDisplay[category] === DisplayCategory.None}
                    >{t("[REACT_SYSTEM_VIEW_LABEL_AREA]")}</div>}
                    <SettingsTextInput
                        inputType="number"
                        text={isMobile ? '[REACT_SYSTEM_VIEW_LABEL_AREA]' : ''}
                        textAlign="right"
                        disabled={allowedToEdit ? (systemDisplay[category] === DisplayCategory.None) : true}
                        value={`${systemDisplay[zoneFrom]}`}
                        onChange={(value) =>
                        {
                            modifySystemDisplay({ [zoneFrom]: parseInt(value) } as unknown as UserSystemDisplay);
                        }}
                    />{!isMobile && " - "}
                    <SettingsTextInput
                        inputType="number"
                        text={isMobile ? 'COM_FACPMANAGEMENT_FACP_APP_FIELD_TO' : ''}
                        textAlign="right"
                        disabled={allowedToEdit ? (systemDisplay[category] === DisplayCategory.None) : true}
                        value={`${systemDisplay[zoneTo]}`}
                        onChange={(value) =>
                        {
                            modifySystemDisplay({ [zoneTo]: parseInt(value) } as unknown as UserSystemDisplay);
                        }}
                    />
                    <IonButton
                        disabled={allowedToEdit ? (systemDisplay[category] === DisplayCategory.None) : true}
                        onClick={() =>
                        {
                            modifySystemDisplay({ [zoneFrom]: 1, [zoneTo]: MAX_DEVICE_NUMBER } as unknown as UserSystemDisplay);
                        }}
                    >{t('[REACT_SYSTEM_VIEW_LABEL_AREA]')}</IonButton>
                </Wrapper>;
            })}

            <SettingsCheckbox
                disabled={!allowedToEdit}
                checked={systemDisplay.filterOnServer}
                onChange={(filterOnServer) =>
                {
                    modifySystemDisplay({ filterOnServer } as UserSystemDisplay);
                }}
                text={"[REACT_SYSTEM_VIEW_LABEL_FILTER_ON_SERVER]"}
            />
        </SettingsCol>


    </>;
};

export default SystemViewSettings;
